import { useMemo } from 'react';

import { getIn } from 'formik';

import { withStore } from '../../store';
import { cities } from '../../utils/constants';
import Select from '../Select';


type City = {
  stateKey: string;
  [key: string]: string | number | boolean;
};

type Customer = Record<string, unknown>;

type Store = {
  customer: Customer;
};

type CitySelectProps = {
  name: string;
  store: Store;
  [key: string]: unknown; // to allow passing other props to Select
};


function CitySelect(props: CitySelectProps) {
  const { name, store } = props;

  const state = useMemo(() => {
    const split = name.split('.');
    let addressType = split[0];

    if (split.length > 2) {
      addressType = `${split[0]}.${split[1]}`;
    }

    return getIn(store.customer, `${addressType}.state`) as string | undefined;
  }, [store.customer, name]);

  const options = useMemo(
    () =>
      cities.filter(
        (city: City) => city.stateKey === state
      ),
    [state]
  );

  const value = getIn(store.customer, name);

  return (
    <Select
      useValueProp
      {...props}
      value={value}
      options={options}
    />
  );
}


export default withStore(CitySelect);